module.exports = __webpack_public_path__ + "img/9788983926487.936e52bf.jpg";